// Resolves the operator-facing name for a device. Three-column model
// (agent migration 062):
//
//   1. `alias` — operator-set, survives every discovery overwrite. The
//      highest-priority source: when an operator typed a name, that's
//      what the operator wants to see.
//   2. `hostname` — network-reported (SNMP sysName / DHCP option 12 /
//      syslog header / LLDP). The middle priority: the device is
//      telling us its own name. NULL until something real arrives.
//   3. `auto_hostname` — agent-synthesized placeholder of the shape
//      `discovered-10-30-0-11`. Always present (NOT NULL DEFAULT in
//      PG); the lowest-priority fallback so list views always have
//      something to render even on freshly-discovered IP-only devices.
//
// The pre-migration-062 displayName muddled hostname and auto_hostname
// in the same column with a `LIKE 'discovered-%'` string check at the
// dashboard layer; that gave a confusing "italic gray" rendering when
// SNMP/DHCP hadn't reported a real hostname yet, and was vulnerable to
// the proxy_ingest clobber bug (PR fixing proxy_ingest.rs:1601). The
// three-column model surfaces provenance structurally.

export function displayName(device) {
  if (!device) return '';
  if (device.alias && device.alias.trim()) return device.alias;
  if (device.hostname && device.hostname.trim()) return device.hostname;
  if (device.auto_hostname && device.auto_hostname.trim()) return device.auto_hostname;
  if (device.ip_address) return `discovered-${stripPrefix(device.ip_address)}`;
  return 'unknown device';
}

/**
 * Which source produced the value `displayName()` returned. Used by the
 * Devices column / DeviceDetail panel to render a small provenance
 * badge ("via SNMP", "operator-assigned", "auto-discovered").
 *
 * Returns one of: 'alias' | 'hostname' | 'auto_hostname' | 'fallback'.
 */
export function displayNameSource(device) {
  if (!device) return 'fallback';
  if (device.alias && device.alias.trim()) return 'alias';
  if (device.hostname && device.hostname.trim()) return 'hostname';
  if (device.auto_hostname && device.auto_hostname.trim()) return 'auto_hostname';
  return 'fallback';
}

function stripPrefix(ip) {
  return typeof ip === 'string' ? ip.replace(/\/\d+$/, '') : ip;
}
